const isProd = process.env.NODE_ENV === 'production' ? 'production' : 'develop';

export const AppUrl = `http://chasma.eu/client_console/${isProd}/console/api/similarController.php`;
export const domain = `http://chasma.eu/`;
